const id_whs_returncus = {
    "": "retur pelanggan",
    detail: "detail retur pelanggan",
}

export default id_whs_returncus;